import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StatusCustomDropdown from "../common/StatusCustomDropdown";
import config from "../../envconfig";
import { UserContext } from "../common/UserContext";
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import ReactSelectDropDown from "../common/ReactSelectDropDown";
import { TurkishLira } from "lucide-react";
function CITPM() {
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
    UM_UserType
  } = useContext(UserContext);
  const [pwdValidationReset, setPwdValidationReset] = useState(false);

  const [formdata, setFormValue] = useState({
    CITPM_PolicyName: "",
    CITPM_PolicyType: "",
    CITPM_SessionTimeOut: "",
    CITPM_FailAttempt: "",
    passwordNeverExpire: false,
    CITPM_PwdChangeDuration: "",
    CITPM_PwdNotificationDuration: "",
    CITPM_Status: 1,
    CITPM_CreatedBy: UM_UserId,
    CITPM_ModifiedBy: UM_UserId,
    CITPM_CompanyGrpID: UM_CompanyGrpID,
    CITPM_CompanyID: UM_CompanyID,
    Company_Name: "",
  });

  const [companyNames, setCompanyNames] = useState([]);
  const [passwordNeverExpire, setPasswordNeverExpire] = useState(false);
  const [message, setMessage] = useState();
  const [errorMessages, setErrorMessages] = useState({});
  const [submittedWithoutValue, setSubmittedWithoutValue] = useState(false);
  const [companynameEmpty, setCompanynameEmpty] = useState(false);
  const [showSelectCompany, setShowSelectCompany] = useState(false);
  const isSuperAdmin = parseInt(UM_UserType) === 0;
  const [scps, setScps] = useState([]);
  const [selectedSCP, setSelectedSCP] = useState("");

  const [isSelectOpen, setIsSelectOpen] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedCompanyOption, setSelectedCompanyOption] = useState(null);

  const [loading, setLoading] = useState(false);


  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Company IT Policy Master",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });

      if (!response.ok) {
        logAction("Failed to log action");
        throw new Error("Failed to log action");
      }
    } catch (error) {
      logAction("Error logging action:", true);
      console.error("Error logging action:", error);
    }
  };


  useEffect(() => {
    const fetchCompanyNames = async () => {
      try {
        const response = await fetch(`${config.API_URL}/CITPM/CMNAME`);
        if (!response.ok) {
          throw new Error("Error fetching company names");
        }
        const data = await response.json();
        const filteredCompanies = data.filter(
          (company) => company.CM_Status === 1
        );
        if (filteredCompanies.length > 0) {
          const formattedCompanies = filteredCompanies.map((company) => ({
            value: company.CM_ID,
            label: company.CM_CompanyName,
            CM_ID: company.CM_ID,
            CM_CompanyGrpID: company.CM_CompanyGrpId,  // <--- FIX NAME HERE
          }));
          console.log("formattedCompanies", formattedCompanies)
          setCompanyNames(formattedCompanies);
        } else {
          console.error("No active companies found.");
          setMessage("No active companies found.");
        }
      } catch (error) {
        console.error("Failed to fetch company names:", error);
        setMessage("Failed to fetch company names. Please check your network connection.");
      }
    };
    fetchCompanyNames();
    fetchCompanyNameForSuperAdmin();
    checkUserRole();
  }, []);

  useEffect(() => {
    const fetchEnumOptions = async () => {
      try {
        const response = await fetch(`${config.API_URL}/CITPM/enumtype`);
        if (!response.ok) throw new Error('Failed to fetch enum options');
        const data = await response.json();

        let formattedOptions = data.map((item) => ({
          value: item.EnumVal,
          label: item.Description
        }));

        if (parseInt(UM_UserType) === 1) {
          formattedOptions = formattedOptions.filter(opt => opt.value !== 1);
        } else if (parseInt(UM_UserType) === 2 || parseInt(UM_UserType) === 3) {
          formattedOptions = [];
        }

        setOptions(formattedOptions);
        setFormValue((prev) => ({
          ...prev,
          CITPM_PolicyType: formattedOptions.length === 1 ? formattedOptions[0].value : ""
        }));
        console.log("formattedOptions", formattedOptions)

        // Auto-select if there is only one option and not in edit mode
        if (formattedOptions.length === 1) {
          setSelectedOption(formattedOptions[0]);
        }
      } catch (error) {
        console.error('Error fetching enum options:', error);
      }
    };
    fetchEnumOptions();
  }, []);

  useEffect(() => {
    const fetchSCPData = async () => {
      try {
        const companyId = parseInt(UM_UserType) === 0
          ? selectedCompanyOption?.CM_ID
          : UM_CompanyID;
        console.log("companyId", selectedCompanyOption, selectedCompanyOption?.value)

        if (!companyId) return;


        const response = await fetch(`${config.API_URL}/UM/scpdata`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ companyId, UM_UserType, UM_UserId }),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        const formattedScps = data.map((scp) => ({
          value: scp.SCPM_ID,
          label: scp.SCPM_Name,
        }));

        console.log("formattedScps", formattedScps)
        setScps(formattedScps);
      } catch (error) {
        console.error("Error fetching SCP data:", error);
      }
    };

    fetchSCPData();
  }, [selectedCompanyOption, selectedOption, UM_CompanyID, UM_UserType]);

  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);

    sessionStorage.setItem("UM_UserType", UM_UserType);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
    UM_UserType
  ]);

  const fetchCompanyNameForSuperAdmin = () => {
    fetch(`${config.API_URL}/CITPM/CMNAME`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.length > 0) {
          const formattedCompanies = data.map((company) => ({
            value: company.CM_CompanyName,
            label: company.CM_CompanyName,
            CM_ID: company.CM_ID,
            CM_CompanyGrpId: company.CM_CompanyGrpId,
          }));
          setCompanyNames(formattedCompanies);
        } else {
          console.error("No company names found.");
        }
      })
      .catch((error) => {
        console.error("Error fetching company names:", error);
      });
  };

  const checkUserRole = () => {
    setShowSelectCompany(parseInt(UM_UserType) === 0);
  };

  const validateInput = (fieldName, value) => {
    if (value === "") {
      return "";
    }
    switch (fieldName) {
      case "CITPM_PolicyName":
        const validCharactersRegex = /^[a-zA-Z0-9\-_. ]*$/;
        const noConsecutiveSpecialRegex = /^(?!.*[-_. ]{2}).*$/;
        const firstLastAlphanumericRegex = /^[a-zA-Z0-9].*[a-zA-Z0-9]$/;
        if (!validCharactersRegex.test(value)) {
          return "Please use only special characters like -, _, Dot (.) and spaces";
        }
        if (!noConsecutiveSpecialRegex.test(value)) {
          return "Invalid: No consecutive special characters.";
        }
        if (value.length > 45) {
          return "Maximum length is 45 characters.";
        }
        break;
      case "CITPM_SessionTimeOut":
      case "CITPM_FailAttempt":
        const numberRegex = /^[1-9][0-9]{0,2}$/;
        if (!numberRegex.test(value)) {
          return "Please enter a valid number between 1 and 999";
        }
        break;
      case "CITPM_PwdChangeDuration":
      case "CITPM_PwdNotificationDuration":
        const durationValue = parseInt(value, 10);
        if (isNaN(durationValue) || durationValue < 0 || durationValue > 999) {
          return `Value must be between 0 and 999.`;
        }
        break;
      default:
        return "";
    }
    return "";
  };

  const handleChange = (e, meta) => {
    if (meta && meta.name === "Company_Name") {
      console.log("📌 Raw from dropdown:", e);

      let selectedOption = null;

      // If ReactSelectDropDown sent a DOM-like event
      if (e?.target) {
        const raw = e.target.value;
        console.log("🔍 e.target.value:", raw);

        selectedOption = companyNames.find(
          (item) =>
            item.value === raw ||                // same type
            item.value === Number(raw) ||        // value is number, raw is string
            item.label === raw                   // some cases where label is passed
        );
      } else {
        // If someday you call onChange with an option object directly
        selectedOption = e;
      }

      console.log("✅ Resolved selectedOption:", selectedOption);

      // Save full object for your logic
      setSelectedCompanyOption(selectedOption);

      const value = selectedOption ? selectedOption.value : "";

      setFormValue((prev) => {
        const updated = {
          ...prev,
          Company_Name: value, // ID
          CITPM_CompanyID: selectedOption ? selectedOption.value : UM_CompanyID,
          CITPM_CompanyGrpID: selectedOption
            ? selectedOption.CM_CompanyGrpId
            : UM_CompanyGrpID,
          CITPM_PolicyType: "", // reset policy name on company change
        };
        console.log("📝 Form updated:", updated);
        return updated;
      });

      setErrorMessages((prev) => ({
        ...prev,
        Company_Name: validateInput("Company_Name", value),
      }));

      return;
    }

    if (meta && meta.name === "CITPM_PolicyType") {
      const selectedVal = e.target.value;
      console.log("selectedVal", selectedVal)

      // Find selected option object
      const selectedObj = options.find(opt => opt.value === selectedVal);

      // Set selected option
      setSelectedOption(selectedObj);

      // If Policy Type is NOT 3, reset dependent values
      if (parseInt(selectedVal) !== 3) {
        setSelectedSCP(null);
        setFormValue((prev) => ({
          ...prev,
          CITPM_SCPID: ""
        }));
      }

      setFormValue((prev) => ({
        ...prev,
        CITPM_PolicyType: selectedVal
      }));

      // Validation
      setErrorMessages((prev) => ({
        ...prev,
        CITPM_PolicyType: validateInput("CITPM_PolicyType", selectedObj),
      }));

      return;

    }

    // 🟥 SELECT (SCP Name)
    if (meta && meta.name === "SCP_Name") {
      const selectedValue = e;
      setSelectedSCP(e.target.value);
      setFormValue((prev) => ({
        ...prev,
        CITPM_SCPID: selectedValue ? selectedValue.value : "",
      }));
      return;
    }

    // 🟨 NORMAL INPUT FIELDS
    const { name, value } = e.target;
    let cleanedValue = value;

    // ✔ Allowed numeric fields (max 3 digits, no leading zero)
    const numericFields = [
      "CITPM_SessionTimeOut",
      "CITPM_PwdChangeDuration",
      "CITPM_PwdNotificationDuration",
      "CITPM_FailAttempt"
    ];

    if (numericFields.includes(name) && !/^(?!0)[0-9]{0,3}$/.test(value)) {
      return; // Block invalid numeric input
    }

    // 🧹 Clear previous duration error (on typing)
    if (name === "CITPM_PwdChangeDuration" || name === "CITPM_PwdNotificationDuration") {
      setErrorMessages((prev) => ({
        ...prev,
        CITPM_PwdNotificationDuration: "",
      }));
    }

    // 🟪 Policy Name Validation (special rules)
    if (name === "CITPM_PolicyName") {

      cleanedValue = cleanedValue.replace(/\s+/g, " ");               // No double spaces
      cleanedValue = cleanedValue.replace(/([-_.])\1+/g, "$1");        // No double special chars

      // First character MUST be alphanumeric
      if (cleanedValue && !/^[a-zA-Z0-9]/.test(cleanedValue[0])) return;

      // Regex allowed + max 100
      const regex = /^[a-zA-Z0-9 _\-.]{0,45}$/;
      if (!regex.test(cleanedValue)) return;

      // First & last must be alphanumeric
      if (cleanedValue.length > 0) {
        const firstChar = cleanedValue[0];
        const lastChar = cleanedValue[cleanedValue.length - 1];

        if (!/^[a-zA-Z0-9]$/.test(firstChar) || !/^[a-zA-Z0-9]$/.test(lastChar)) {
          setErrorMessages((prev) => ({
            ...prev,
            [name]: "First and last character must be alphanumeric",
          }));
        } else {
          setErrorMessages((prev) => ({
            ...prev,
            [name]: "",
          }));
        }
      }

      setFormValue((prev) => ({
        ...prev,
        [name]: cleanedValue,
      }));
      return;
    }

    // 🟩 Update form for normal fields
    setFormValue((prev) => ({
      ...prev,
      [name]: cleanedValue,
    }));


    // 🟥 LIVE VALIDATION: Notification < Change Duration
    if (
      name === "CITPM_PwdChangeDuration" ||
      name === "CITPM_PwdNotificationDuration"
    ) {
      const changeDuration = parseInt(
        name === "CITPM_PwdChangeDuration" ? cleanedValue : formdata.CITPM_PwdChangeDuration
      );
      const notification = parseInt(
        name === "CITPM_PwdNotificationDuration" ? cleanedValue : formdata.CITPM_PwdNotificationDuration
      );

      if (
        !passwordNeverExpire &&
        changeDuration &&
        notification &&
        notification >= changeDuration
      ) {
        setErrorMessages((prev) => ({
          ...prev,
          CITPM_PwdNotificationDuration:
            "Password Expire Notification must be less than Password Change Duration.",
        }));
      } else {
        setErrorMessages((prev) => ({
          ...prev,
          CITPM_PwdNotificationDuration: "",
        }));
      }
    }
  };

  const handleCancel = () => {
    setFormValue({
      CITPM_PolicyName: "",
      CITPM_SessionTimeOut: "",
      CITPM_FailAttempt: "",
      CITPM_PwdChangeDuration: "",
      CITPM_PwdNotificationDuration: "",
      CITPM_Status: 1,
      passwordNeverExpire: false,
      Company_Name: "",
    });

    setSelectedCompanyOption(null);

    // Reset only for Super Admin (UserType 0)
    if (parseInt(UM_UserType) === 0 || (parseInt(UM_UserType) === 1 && options.length > 1)) {
      setSelectedOption(null);

    }
    setSelectedSCP(null);
    setMessage("");
    setErrorMessages({});
    setSubmittedWithoutValue(false);
    setCompanynameEmpty(false);
    setPasswordNeverExpire(false);
  };
  const checkDuplicate = async () => {
    try {
      setLoading(true);
      const selectedCompany = companyNames.find(
        (company) => company.value === formdata.Company_Name
      ) || {};

      // Compute the values
      const CITPM_SCPID =
        (parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) && selectedOption?.value === 3
          ? selectedSCP
          : parseInt(UM_UserType) === 2
            ? 0
            : parseInt(UM_UserType) === 3
              ? selectedScpId
              : 0;

      const CITPM_PolicyType =
        (parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1)
          ? selectedOption?.value
          : UM_UserType;

      console.log("selectedCompany.CM_ID", selectedCompany.CM_ID, CITPM_SCPID)

      const res = await fetch(
        `${config.API_URL}/CITPM/CITPM_CHECK_DUPLICATE`,
        {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({
            CITPM_PolicyName: formdata.CITPM_PolicyName,
            CITPM_CompanyID: parseInt(UM_UserType) === 0 ? selectedCompany.CM_ID : UM_CompanyID,
            CITPM_SCPID,        // added
            CITPM_PolicyType,   // added
          }),
        }
      );

      if (res.ok) {
        const data = await res.json();
        if (data.error) {
          toast.error(`Policy : ${formdata.CITPM_PolicyName} already exists.`,{ onClose: () => setLoading(false) });
          return false;
        } else {
          return true;
        }
      } else {
        console.error("Error in checking duplicate record.");
        toast.error(`Policy : ${formdata.CITPM_PolicyName} already exists.`, { onClose: () => setLoading(false) });
        return false;
      }
    } catch (error) {
      console.error("Network error:", error);
      toast.error("Network error. Please try again later.");
      setLoading(false);
      return false;
    }
  };

  const logAudit = async (
    module,
    message,
    CompanyID,
    CompanyGrpID,
    oldValue = "",
    newValue = "",
    isError = false,
    transactionDetails = []
  ) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_CompanyGrpId: CompanyGrpID,
      AUTR_CompanyID: CompanyID,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 3,
      AUTR_SCPID: selectedScpId || 0,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0, // Flag to determine if transaction details should be inserted
      transactionDetails, // Array of transaction details to be inserted into audittransaction
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  const handleSubmit = async (e) => {
    console.log("CITPM DETAILS", parseInt(formdata.CITPM_PwdChangeDuration), parseInt(formdata.CITPM_PwdNotificationDuration))
    e.preventDefault();
    setPwdValidationReset(false);
    setSubmittedWithoutValue(true);

    const requiredFields = [
      "CITPM_PolicyName",
      "CITPM_PolicyType",
      "CITPM_SessionTimeOut",
      "CITPM_FailAttempt",
    ];
    const isEmpty = requiredFields.some((field) => !formdata[field]);
    const isPasswordFieldsNotFilled =
      !passwordNeverExpire &&
      ["CITPM_PwdChangeDuration", "CITPM_PwdNotificationDuration"].some(
        (field) => !formdata[field]
      );
    const isCompanyNameEmptyForSuperAdmin =
      parseInt(UM_UserType) === 0 && !formdata.Company_Name;

    const isSCPNotSelected =
      (parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) && selectedOption?.value === 3 && !selectedSCP;

    console.log("isPasswordFieldsNotFilled", isCompanyNameEmptyForSuperAdmin, isSCPNotSelected, isPasswordFieldsNotFilled, selectedSCP)
    const isAnyFieldInvalid =
      isEmpty ||
      isPasswordFieldsNotFilled ||
      isCompanyNameEmptyForSuperAdmin || isSCPNotSelected;
console.log("isanyfieldinvalid", isAnyFieldInvalid)
console.log("isempty", isEmpty, isPasswordFieldsNotFilled, isCompanyNameEmptyForSuperAdmin, isSCPNotSelected)
    if (isAnyFieldInvalid) {
      console.error("Validation failed. Please fill all required fields.");
      return;
    }

    if (parseInt(formdata.CITPM_PwdChangeDuration) <= parseInt(formdata.CITPM_PwdNotificationDuration)) {
      const message = "Password Expire Notification must be less than Password Change Duration.";

      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        CITPM_PwdNotificationDuration: message,
      }));

      return;
    }



    const isDuplicate = await checkDuplicate();
    if (isDuplicate) {
      let selectedCompany;
      if (isSuperAdmin && formdata.Company_Name) {
        selectedCompany = companyNames.find(
          (company) => company.value === formdata.Company_Name
        ) || {};
      }
      try {


        const companyID =
          parseInt(UM_UserType) === 0
            ? selectedCompany.CM_ID
            : UM_CompanyID;

        const CompanyGroupID =
          parseInt(UM_UserType) === 0
            ? selectedCompany?.CM_CompanyGrpId
            : UM_CompanyGrpID;
        console.log("selectedCompany", companyID, CompanyGroupID)


        const requestData = {
          CITPM_PolicyName: formdata.CITPM_PolicyName,
          CITPM_SessionTimeOut: formdata.CITPM_SessionTimeOut,
          CITPM_FailAttempt: formdata.CITPM_FailAttempt,
          CITPM_PwdChangeDuration: passwordNeverExpire
            ? "-"
            : formdata.CITPM_PwdChangeDuration,
          CITPM_PwdNotificationDuration: passwordNeverExpire
            ? "-"
            : formdata.CITPM_PwdNotificationDuration,
          CITPM_PwdNeverExpiry: passwordNeverExpire ? 1 : 0,
          CITPM_Status: formdata.CITPM_Status,
          CITPM_CreatedBy: UM_UserId,
          CITPM_ModifiedBy: UM_UserId,
          CITPM_CompanyID: companyID,
          CITPM_CompanyGrpID: CompanyGroupID,
          CITPM_SCPID:
            (parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) && selectedOption?.value === 3
              ? selectedSCP
              : parseInt(UM_UserType) === 2
                ? 0
                : parseInt(UM_UserType) === 3
                  ? selectedScpId
                  : 0,


          CITPM_PolicyType: (parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1)
            ? selectedOption?.value
            : UM_UserType
        };

        const transactionDetails = [
          {
            AUTRN_OldValue: "-",
            AUTRN_NewValue: formdata.CITPM_PolicyName,
            AUTRN_ParamererName: "Policy Name",
          },


          ...(
            !(
              parseInt(UM_UserType) === 2 ||
              ((parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) && selectedOption?.value !== 3)
            )
              ? [
                {
                  AUTRN_OldValue: "-",
                  AUTRN_NewValue:
                    (parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) && selectedOption?.value === 3
                      ? selectedSCP?.label
                      : parseInt(UM_UserType) === 3
                        ? selectedScpId
                        : 0,
                  AUTRN_ParamererName: "SCP Name",
                },
              ]
              : []
          ),

          ...(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1
            ? [
              {
                AUTRN_OldValue: "-",
                AUTRN_NewValue: selectedOption?.label,
                AUTRN_ParamererName: "Policy Type",
              },
            ]
            : []),
          {
            AUTRN_OldValue: "-",
            AUTRN_NewValue: formdata.CITPM_SessionTimeOut,
            AUTRN_ParamererName: "Session Time Out (Minutes)",
          },
          {
            AUTRN_OldValue: "-",
            AUTRN_NewValue: formdata.CITPM_FailAttempt,
            AUTRN_ParamererName: "Password Attempts",
          },
          {
            AUTRN_OldValue: "-",
            AUTRN_NewValue: parseInt(passwordNeverExpire) === 1
              ? "N/A"
              : formdata.CITPM_PwdChangeDuration,
            AUTRN_ParamererName: "Password Change Duration (Days)",
          },
          {
            AUTRN_OldValue: "-",
            AUTRN_NewValue: parseInt(passwordNeverExpire) === 1
              ? "N/A"
              : formdata.CITPM_PwdNotificationDuration,
            AUTRN_ParamererName: "Password Expire Notification (Days)",
          },

          {
            AUTRN_OldValue: "-",
            AUTRN_NewValue: parseInt(passwordNeverExpire) === 1 ? "True" : "False",
            AUTRN_ParamererName: "Password Never Expire",
          },
          {
            AUTRN_OldValue: "-",
            AUTRN_NewValue: parseInt(formdata.CITPM_Status) === 1 ? "Active" : "Inactive",
            AUTRN_ParamererName: "Status",
          },
        ];



        logAudit(
          "Company IT Policy Master",
          `Policy : ${formdata.CITPM_PolicyName} saved successfully`, companyID, CompanyGroupID,
          "-",
          `${formdata.CITPM_PolicyName}`,
          false,
          transactionDetails
        );
        console.log("requestData", requestData)
        logAction(`handleSubmit() : Executing API : ${config.API_URL}/CITPM/CITPM_INSERT with DATA : ${requestData}`);
        setLoading(true);
        const response = await fetch(
          `${config.API_URL}/CITPM/CITPM_INSERT`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          }
        );

        if (response.ok) {
          toast.success(
            `Policy : ${formdata.CITPM_PolicyName} saved successfully.`,
            {
              onClose: () => {
                handleCancel();
                setFormValue({
                  CITPM_PolicyName: "",
                  CITPM_SessionTimeOut: "",
                  CITPM_FailAttempt: "",
                  CITPM_PwdChangeDuration: "",
                  CITPM_PwdNotificationDuration: "",
                  CITPM_Status: 1,
                  passwordNeverExpire: false,
                  Company_Name: "",
                  CITPM_PolicyType: "",
                  CITPM_SCPID: "",
                });
                setLoading(false);
                setSelectedCompanyOption(null);
              }
            }
          );

          logAction(`handleSubmit() : Policy : ${formdata.CITPM_PolicyName} saved successfully`);

        } else {
          const errorText = await response.text(); // or response.json() if API returns JSON
          console.error("Error in saving data:", errorText);

          toast.error("Some error occurred while saving data.", { onClose: () => setLoading(false) });
          logAction(
            `handleSubmit() : Error in saving data with API : ${config.API_URL}/CITPM/CITPM_INSERT | Status: ${response.status} ${response.statusText} | Details: ${errorText}`, true
          );
        }
      } catch (error) {
        console.error("Network error:", error);
        toast.error("Network error. Please try again later.", { onClose: () => setLoading(false) });
        logAction(`handleSubmit() : Error in saving data with API : ${config.API_URL}/CITPM/CITPM_INSERT | Error : ${error}`, true);
      }
    }
  };

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

  return (
    <React.Fragment>

      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      {loading && (
        <div style={{
          position: 'fixed', // Sit on top of the page content
          left: 0,
          top: 0,
          width: '100%', // Full width
          height: '100%', // Full height
          zIndex: 1000 // Sit on top of the other elements
        }} />
      )}

      <form onSubmit={handleSubmit}>
        <div className="main_container">
          <h3 className="formHeading"> Company IT Policy Master</h3>
          <div className="row">
            <div className="col-md-12">

              <div className="row">
                {isSuperAdmin && showSelectCompany && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Company Name
                        {isSuperAdmin &&
                          !formdata.Company_Name &&
                          submittedWithoutValue && (
                            <span className="text-danger">*</span>
                          )}
                      </label>
                      <div className="select-container_list">
                        <ReactSelectDropDown
                          name="Company_Name"
                          options={companyNames}
                          value={selectedCompanyOption?.value ?? ""} // 👈 pass primitive ID
                          onChange={(option) => handleChange(option, { name: "Company_Name" })}
                          placeholder="--Select--"
                          idKey="value"
                          displayKey="label"
                          disabled={false}
                          onMenuOpen={() => handleSelectOpen("Company_Name")}
                          onMenuClose={handleSelectClose}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Policy Name
                      {submittedWithoutValue && !formdata.CITPM_PolicyName && (
                        <span className="text-danger">*</span>
                      )}
                    </label>
                    <input
                      type="text"
                      name="CITPM_PolicyName"
                      className={`form-input ${errorMessages.CITPM_PolicyName ? "is-invalid" : ""
                        }`}
                      placeholder=""
                      value={formdata.CITPM_PolicyName}
                      onChange={handleChange}
                    />
                    {errorMessages.CITPM_PolicyName && (
                      <div className="text-danger mt-1">
                        {errorMessages.CITPM_PolicyName}
                      </div>
                    )}
                  </div>
                </div>

                {(parseInt(UM_UserType) !== 2 && parseInt(UM_UserType) !== 3) && options.length > 1 && (
                  <div className="col-md-6">

                    <div className="mb-3">
                      <label htmlFor="productName" className="form-label">
                        Policy Type
                        {submittedWithoutValue && !formdata.CITPM_PolicyType && (
                          <span className="text-danger">*</span>
                        )}
                      </label>
                      <div className="select-container_list">
                        <ReactSelectDropDown
                          name="CITPM_PolicyType"
                          options={options}
                          value={formdata.CITPM_PolicyType || ""}   // only value needed
                          placeholder="--Select--"
                          idKey="value"
                          displayKey="label"
                          disabled={formdata.Company_Name === ""}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              backgroundColor: state.isDisabled ? "#f2f2f2" : base.backgroundColor,
                              color: state.isDisabled ? "#6c757d" : base.color,
                              cursor: state.isDisabled ? "not-allowed" : "pointer",
                            }),
                          }}
                          onChange={(option) => handleChange(option, { name: "CITPM_PolicyType" })}
                          // onChange={(e) => {
                          //   const selectedVal = e.target.value;

                          //   // update dropdown selected object if needed
                          //   const selectedObj = options.find(opt => opt.value === selectedVal);
                          //   setSelectedOption(selectedObj);

                          //   if (selectedVal !== 3) {
                          //     setSelectedSCP(null);
                          //     setFormValue((prev) => ({
                          //       ...prev,
                          //       CITPM_SCPID: ""
                          //     }));
                          //   }
                          // }}
                          onMenuOpen={() => handleSelectOpen("PType")}
                          onMenuClose={handleSelectClose}
                        />


                      </div>
                    </div>

                  </div>
                )}

                {(
                  (
                    (parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) && parseInt(selectedOption?.value) === 3
                  )
                ) && (
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          SCP Name
                          {submittedWithoutValue && !selectedSCP && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <div className="select-container_list">
                          <ReactSelectDropDown
                            name="SCP_Name"
                            options={scps}
                            value={selectedSCP}                              // only value needed
                            onChange={(option) => handleChange(option, { name: "SCP_Name" })}
                            placeholder="--Select--"
                            idKey="value"                                           // id for SCP options
                            displayKey="label"                                      // label for SCP options
                            disabled={false}
                            onMenuOpen={() => handleSelectOpen("SCP_Name")}
                            onMenuClose={handleSelectClose}
                          />


                        </div>
                      </div>
                    </div>
                  )}

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Password Attempts
                      {submittedWithoutValue && !formdata.CITPM_FailAttempt && (
                        <span className="text-danger">*</span>
                      )}
                    </label>
                    <input
                      type="text"
                      name="CITPM_FailAttempt"
                      className={`form-input ${errorMessages.CITPM_FailAttempt ? "is-invalid" : ""
                        }`}
                      placeholder=""
                      value={formdata.CITPM_FailAttempt}
                      onChange={handleChange}
                    />
                    {errorMessages.CITPM_FailAttempt && (
                      <div className="text-danger">
                        {errorMessages.CITPM_FailAttempt}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Session Time Out (Minutes)
                      {submittedWithoutValue &&
                        !formdata.CITPM_SessionTimeOut && (
                          <span className="text-danger">*</span>
                        )}
                    </label>
                    <input
                      type="text"
                      name="CITPM_SessionTimeOut"
                      className={`form-input ${errorMessages.CITPM_SessionTimeOut ? "is-invalid" : ""
                        }`}
                      placeholder=""
                      value={formdata.CITPM_SessionTimeOut}
                      onChange={handleChange}
                    />
                    {errorMessages.CITPM_SessionTimeOut && (
                      <div className="text-danger">
                        {errorMessages.CITPM_SessionTimeOut}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <div className="select-container_list">
                      <StatusCustomDropdown
                        name="CITPM_Status"
                        options={[
                          { value: 1, label: "Active" },
                          { value: 2, label: "Inactive" },
                        ]}
                        value={formdata.CITPM_Status || 1}
                        onChange={handleChange}
                        idKey="value"
                        displayKey="label"
                        enableScrollEffect={passwordNeverExpire ? true : false}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">

                    <label>Password Never Expire</label>

                    <input
                      type="checkbox"
                      name="passwordNeverExpire"
                      className="form-check-input"
                      checked={passwordNeverExpire}
                      onChange={() => {
                        const newValue = !passwordNeverExpire;
                        setPasswordNeverExpire(newValue);
                        setPwdValidationReset(true);
                        if (newValue) {
                          setFormValue((prev) => ({
                            ...prev,
                            CITPM_PwdChangeDuration: "",
                            CITPM_PwdNotificationDuration: "",
                          }));
                          setErrorMessages((prev) => ({
                            ...prev,
                            CITPM_PwdChangeDuration: "",
                            CITPM_PwdNotificationDuration: "",
                          }));
                        }
                      }}
                      style={{ marginLeft: "2px", width: "20px", height: "20px" }}
                    />


                  </div>
                </div>
                {!passwordNeverExpire && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Password Change Duration (Days)
                        {!passwordNeverExpire &&
                          submittedWithoutValue &&
                          !pwdValidationReset &&
                          !formdata.CITPM_PwdChangeDuration && (
                            <span className="text-danger">*</span>
                          )}

                      </label>
                      <input
                        type="text"
                        name="CITPM_PwdChangeDuration"
                        className={`form-input inputfields ${errorMessages.CITPM_PwdChangeDuration
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder=""
                        value={formdata.CITPM_PwdChangeDuration}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )}

                {!passwordNeverExpire && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Password Expire Notification (Days)
                        {!passwordNeverExpire &&
                          submittedWithoutValue &&
                          !pwdValidationReset &&
                          !formdata.CITPM_PwdNotificationDuration && (
                            <span className="text-danger">*</span>
                          )}
                      </label>
                      <input
                        type="text"
                        name="CITPM_PwdNotificationDuration"
                        className={`form-input inputfields ${errorMessages.CITPM_PwdNotificationDuration
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder=""
                        value={formdata.CITPM_PwdNotificationDuration}
                        onChange={handleChange}
                      />
                      {errorMessages.CITPM_PwdNotificationDuration && (
                        <div className="text-danger">
                          {errorMessages.CITPM_PwdNotificationDuration}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="button-container">
          {/* <label className="form-label"></label>
          {Object.entries(errorMessages).map(([fieldName, errorMessage]) => (
            <div key={fieldName} className="text-danger">
              {errorMessage}
            </div>
          ))} */}
          <button
            type="submit"
            className="save_btn"
            disabled={Object.values(errorMessages).some((msg) => msg)}
          >
            SAVE
          </button>
          <button type="reset" className="reset_btn" onClick={handleCancel}>
            RESET
          </button>
          <Link to={`/citpm_list`} className="list_btn" type="button">
            LIST
          </Link>
        </div>
      </form>
    </React.Fragment>
  );
}

export default CITPM;